import { useEffect } from 'react';
import useEventEmitter from './useEventEmitter';
import PropTypes from 'prop-types';

const useEmitterListener = (componentName, eventName, listenerHandler) => {
    const applyEmitterHandler = useEventEmitter(componentName);
    
    useEffect(() => { 
        applyEmitterHandler((emitter) => {
            emitter.addListener(eventName, listenerHandler);
        });
    
        return () => {
            applyEmitterHandler((emitter) => {
                emitter.removeListener(eventName, listenerHandler);
            });
        }
    }, [applyEmitterHandler, eventName, listenerHandler]);
}

useEmitterListener.propTypes = {
    componentName: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    listenerHandler: PropTypes.func.isRequired
}

export default useEmitterListener;
